import script from "./MagicLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./MagicLink.vue?vue&type=script&setup=true&lang=ts"

import "./MagicLink.vue?vue&type=style&index=0&id=940579c4&lang=scss"

const __exports__ = script;

export default __exports__